import React from 'react';
import { useTranslation } from 'react-i18next';
import { User, Scale, Users, ClipboardCheck } from 'lucide-react';
import DetailTile from './DetailTile';
import { getPropertyValue } from '../../../services/traceability-api';

const GoodsCollectedView = ({ isMobile, data }) => {
    const { t } = useTranslation();
    
    const properties = data?.properties || [];
    const batch = data?.batch;
    
    // Extract values from properties or batch
    const fieldOfficer = getPropertyValue(properties, 'Field Officer') 
        || (batch?.createdBy ? `${batch.createdBy.username || ''} ${batch.createdBy.lastName || ''}`.trim() : '—');
    const totalWeight = getPropertyValue(properties, 'Total Weight') 
        || getPropertyValue(properties, 'Quantity')
        || (batch?.totalYield ? `${batch.totalYield} ${batch.unit || 'kg'}` : '—');
    const farmerCount = getPropertyValue(properties, 'Farmer Count')
        || getPropertyValue(properties, 'Farmers')
        || (batch?.contributingFarmerCount ? `${batch.contributingFarmerCount} Contributed` : '—');
    const qualityGrade = getPropertyValue(properties, 'Quality Grade') 
        || getPropertyValue(properties, 'Quality')
        || '—';
    const moisture = getPropertyValue(properties, 'Moisture') || getPropertyValue(properties, 'Moisture Level');

    return (
        <div className="animate-fade-in p-0">
            {moisture && (
                <div className="trace-banner info">
                    <div className="side-line"></div>
                    <p>
                        Moisture level recorded at {moisture} — within optimal range for transport.
                    </p>
                </div>
            )}

            <div className="row g-3">
                <DetailTile isMobile={isMobile} icon={<User size={16} />} title="Field Officer" value={fieldOfficer} />
                <DetailTile isMobile={isMobile} icon={<Scale size={16} />} title="Total Weight" value={totalWeight} />
                <DetailTile isMobile={isMobile} icon={<Users size={16} />} title="Farmers" value={farmerCount} />
                <DetailTile isMobile={isMobile} icon={<ClipboardCheck size={16} />} title="Quality Grade" value={qualityGrade} />
            </div>
        </div>
    );
};

export default GoodsCollectedView;
